import BASE_URL from '@naruto/bgdcms/src/base/url';
import ADMIN_PAGE_KEY from '@naruto/bgdcms/src/base/routes/AdminPageKey';
import { Routes } from '@naruto/bgdcms/src/base/routes/types';

const ADMIN_URL = BASE_URL.ADMIN;

const Admin: Routes = {
  main: [
    {
      id: ADMIN_PAGE_KEY.PROJECT_OVERVIEW,
      route: `${ADMIN_URL.ROOT_PAGE_PROJECT_OVERVIEW}`,
      component: import('@naruto/bgdcms/src/components/Pages/Project/ProjectOverview'),
      exact: false,
      showInSidebar: false,
      subRoute: [],
      lang: '',
      icon: '',
      iconActive: ''
    },
    {
      id: ADMIN_PAGE_KEY.PROJECT_DETAIL_UPDATE,
      route: `${ADMIN_URL.ROOT_PAGE_PROJECT_DETAIL_TYPE}${ADMIN_URL.ROOT_PAGE_PROJECT_DETAIL}`,
      component: import('@naruto/bgdcms/src/components/Pages/Project/ProjectDetail'),
      exact: false,
      showInSidebar: false,
      subRoute: [],
      lang: '',
      icon: '',
      iconActive: ''
    },
    {
      id: ADMIN_PAGE_KEY.PROJECT_DETAIL_CREATE,
      route: `${ADMIN_URL.ROOT_PAGE_PROJECT_DETAIL_TYPE}`,
      component: import('@naruto/bgdcms/src/components/Pages/Project/ProjectDetail'),
      exact: false,
      showInSidebar: false,
      subRoute: [],
      lang: '',
      icon: '',
      iconActive: ''
    }
  ]
};

export default Admin;
